import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';
import { BORDER_RADIUS_L, BORDER_RADIUS_M, FontFamilies, FontWeights } from 'shared/config';

export const getMuiTextFieldOverrides = (theme: Theme): ComponentsOverrides['MuiTextField'] => ({
  root: {
    width: '100%',
    '.MuiInputBase-root': {
      padding: '14px 20px',
      height: 64,
      background: `${theme.themeColors.colorTextFieldBackground}`,
      border: `1.5px solid ${theme.themeColors.colorTextFieldBackground}`,
      borderRadius: BORDER_RADIUS_M,
      '&:placeholder': {
        color: theme.themeColors.colorTextFieldFormLabel,
      },
      '&::after, &::before': {
        display: 'none',
      },
      '&:hover': {
        borderColor: theme.themeColors.colorTextFieldBorder,
        background: `${theme.themeColors.colorTextFieldBackgroundHover}`,
      },
      '&.Mui-focused': {
        borderColor: theme.themeColors.colorTextFieldBorderFocused,
        background: `${theme.themeColors.colorTextFieldBackgroundHover}`,
      },
      '&.Mui-disabled': {
        borderColor: theme.themeColors.colorTextFieldBackground,
      },
      '.MuiInputBase-input': {
        fontSize: 15,
        lineHeight: '24px',
        fontFamily: FontFamilies.primary,
        fontWeight: FontWeights.Regular,
        padding: 0,
        color: theme.themeColors.colorTextFieldColor,
        '&.Mui-disabled': {
          opacity: 0.5,
        },
      },
      '.MuiFilledInput-notchedOutline': {
        padding: 0,
      },
      '&.Mui-error': {
        borderColor: `${theme.themeColors.colorTextFieldColorError}`,
      },
      '&.Mui-error fieldset': {
        borderColor: `${theme.themeColors.colorTextFieldColorError}`,
      },
    },
    '.MuiInputBase-multiline': {
      background: theme.themeColors.colorTextFieldBackground,
      minHeight: 48,
      height: 'min-content',
    },

    '.MuiFormLabel-root': {
      color: theme.themeColors.colorTextFieldFormLabel,
      fontFamily: FontFamilies.primary,
      fontWeight: FontWeights.Regular,
      textTransform: 'capitalize',
      transform: 'translate(22px, 20px)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(22px, 4px)',
        fontSize: 12,
        lineHeight: '22px',
      },
      '&.Mui-focused': {
        color: theme.themeColors.colorsTextFieldFormLabelActive,

        '&.Mui-error': {
          color: `${theme.themeColors.colorTextFieldColorError}`,
        },
      },
    },
    'input:-webkit-autofill': {
      boxShadow: '0 0 0 1000px transparent inset',
      transitionDelay: '999999s',
      transitionProperty: 'background-color, color',
    },

    '&.token': {
      position: 'relative',
      '.MuiInputBase-root': {
        height: 102,
        caretColor: theme.themeColors.colorTextFieldTokenCaret,
        borderRadius: BORDER_RADIUS_L,
        '&:hover': {
          background: `${theme.themeColors.colorTextFieldBackground}`,
        },
        '&.Mui-focused': {
          background: `${theme.themeColors.colorTextFieldBackground}`,
        },
        '.MuiInputBase-input': {
          fontSize: '28px',
          lineHeight: '40px',
          fontFamily: FontFamilies.secondary,
          color: theme.themeColors.colorTextFieldToken,
        },
      },

      '.MuiFormLabel-root': {
        color: theme.themeColors.colorTextFieldTokenLabel,
        '&.MuiInputLabel-shrink': {
          transform: 'translate(22px, 4px)',
          fontSize: 14,
          lineHeight: '24px',
        },
        '&.Mui-focused': {
          color: theme.themeColors.colorsTextFieldFormLabelActive,
          '&.Mui-error': {
            color: `${theme.themeColors.colorTextFieldColorError}`,
          },
        },
      },
      '.MuiFormHelperText-root': {
        position: 'absolute',
        left: 22,
        bottom: 10,
        margin: 0,
        color: theme.themeColors.colorTextFieldColorError,
        fontSize: 12,
        lineHeight: '16px',
      },
    },
  },
});

export const getMuiTextFieldDefaultProps = (): ComponentsProps['MuiTextField'] => ({
  variant: 'filled',
  SelectProps: {
    displayEmpty: true,
  },
  InputProps: {
    autoComplete: 'off',
  },
});
